import { Chip } from "@mui/material"
import type { FC } from "react"
import { twMerge } from "tailwind-merge"

import { ADJUSTMENT_TYPE_TO_LABEL } from "../../Adjustment/constants"
import { ADJUSTMENT_TYPE_TO_CHIP_CLASS } from "../constants"

import type { InventoryAdjustmentType } from "@/graphql/codegen/graphql"

interface AdjustmentTypeChipProps {
  type: InventoryAdjustmentType
}

export const AdjustmentTypeChip: FC<AdjustmentTypeChipProps> = ({ type }) => (
  <Chip
    className={twMerge("h-6 rounded text-xs", ADJUSTMENT_TYPE_TO_CHIP_CLASS[type])}
    label={ADJUSTMENT_TYPE_TO_LABEL[type]}
    size='small'
  />
)
